module.exports = __webpack_public_path__ + "img/fbs_set.3b29c2d0.jpg";